import * as React from 'react';

import type {DashboardStatsFragment as Stat} from 'nutshell-graphql-types';

import {ChangeRow} from '../../metrics/change-row';
import {StatsBlockHorizontal} from '../../metrics/stats-block-horizontal';
import {StatsBlockVertical} from '../../metrics/stats-block-vertical';

import styles from './stats-bar.module.css';

type Props = {
    isHorizontal?: boolean;
    isLoading?: boolean;
    stats: Stat[];
};

export function StatsBar(props: Props) {
    const {isHorizontal = false} = props;

    const stats =
        props.stats.length > 0
            ? props.stats.map((entry) => ({
                  key: entry.name,
                  title: entry.name,
                  value: entry.formattedValue,
                  isLoading: props.isLoading,
                  bottomRow: entry.delta && (
                      <ChangeRow
                          percentChange={entry.delta.percentChange}
                          timespanSuffix={entry.delta.timespanSuffix || ''}
                          changeType={entry.delta.direction}
                      />
                  ),
              }))
            : [];

    return (
        <div
            className={
                isHorizontal ? styles['container--horizontal'] : styles['container--vertical']
            }
        >
            {isHorizontal ? (
                // @ts-expect-error
                <StatsBlockHorizontal stats={stats} size='normal' hasBorders={false} />
            ) : (
                // @ts-expect-error
                <StatsBlockVertical stats={stats} size='normal' hasBorders={false} />
            )}
        </div>
    );
}
